import React, { Component, Fragment } from 'react';
import axios from 'components/AppRequest';
import CommunicateBox from 'components/components/common/CommunicateBox';
import LoadingSpinner from 'components/components/common/LoadingSpinner';
import VerificationInput from 'react-verification-input';
import mergeErrors from 'components/helpers/mergeErrors';
import PasswordMask from 'components/components/common/PasswordMask';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Error } from 'components/common/Form.js';
import CustomerBasicDataValidation from 'components/components/auth/utils/CustomerBasicDataValidation';
import TransHelper from 'components/common/translations/TransHelper';

function SampleEyeShow() {
  return (
    <FontAwesomeIcon
      icon={['fas', 'eye']}
      title="Show"
    />
  );
}

function SampleEyeHide() {
  return (
    <FontAwesomeIcon
      icon={['fas', 'eye-slash']}
      title="Hide"
    />
  );
}

class NewPasswordAndCode extends Component {
  state = {
    error: null,
    isLoading: false,
    password: '',
    errors: {}
  }

  trans = (key,prefix = 'content.auth.newPassswordAndCode') => {
    return TransHelper.translate( this.props.locale, prefix + "." + key);
  }

  transError = (key) => {
    return this.trans(key,'content.errors.auth.newPassswordAndCode');
  }

  createAccountRequest = () => {
    const { password } = this.state;
    var customerValidation = new CustomerBasicDataValidation(false,this.props.locale);
    var isValidPassword = customerValidation.isValidPassword(password);
    if (!isValidPassword) {
      this.setState(
        {
          errors: {
            password: customerValidation.validationPassword(password)
          }
        }
      )
      return;
    }
    if (this.validInput.state.tan.length !== 4 && this.validInput.state.tan.length > 0) {
      this.setState({ error: this.transError('codeFull') });
      return;
    }

    if (this.validInput.state.tan.length == 0) {
      this.setState({ error: this.transError('codeEmpty') });
      return;
    }

    this.setState(
      { isLoading: true, error: null, errors: {} },
      () => {
        const { email } = this.props;
        var params = {
          verification_code: this.validInput.state.tan,
          email: email,
          password: password
        };

        axios.post('/pwa/registration/change-customer-password', params)
          .then(response => {
            this.setState({ isLoading: false, password: '' });
            this.props.resetEmail();
            this.props.toggleView();
            this.props.changeShowCommunicate(true);
          })
          .catch(err => {
            console.log("err", err);
            var mergedErrors = mergeErrors(err.response.data.errors);
            this.setState({
              errors: err.response.data.errors,
              isLoading: false,
              error: mergedErrors
            });
          });
      });
  }

  submitForm = (e) => {
    e.preventDefault();
    this.createAccountRequest();
  }

  handleToggleClick = (e) => {
    e.preventDefault();
    this.props.toggleView();
  }

  handleChangePassword = (e) => {
    this.setState({ password: e.target.value });
  }

  render() {
    const { error, errors, isLoading, password } = this.state;
    const { email } = this.props;

    return (
      <Fragment>
        <header className="head mb-30">
          <h3>{this.trans('title')}</h3>
        </header>
        <div className="content">
          <form onSubmit={this.submitForm}>
            <fieldset>
              <legend className="visuallyhidden">Email Verification Form</legend>
              <p className="text-center mb-25">
                {this.trans('codeTitle')}{' '}
                {this.trans('codeSentTo')}&nbsp;{email}
              </p>

              <CommunicateBox
                isStatic
                message={error}
              />

              <VerificationInput
                autoFocus={true}
                debug={false}
                length={4}
                placeholder=" "
                removeDefaultStyles
                characters={{
                  className: 'characters',
                }}
                character={{
                  className: 'character',
                  classNameInactive: 'character--disabled',
                  classNameSelected: 'character--selected',
                  type: 'number-pad',
                  inputMode: 'numeric',
                }}
                validChars="0-9"
                inputField={{
                  inputMode: 'numeric',
                  type: 'number-pad',
                }}
                ref={ref => this.validInput = ref}
              />

              <ul className="list-fields list-none mb-50">
                <li className="list-fields__item">
                  <label htmlFor="newPass">{this.trans('newPasswordLabel')}</label>
                  <PasswordMask
                    id="newPass"
                    value={password}
                    onChange={this.handleChangePassword}
                    showButtonContent={<SampleEyeShow />}
                    hideButtonContent={<SampleEyeHide />}
                    buttonClassName="button--toggle"
                    className="button-toggle-wrap"
                  />
                  <Error error={errors.password} />
                </li>
              </ul>
              <p className="text-right text-small mb-30" style={{ marginTop: '-20px' }}>
                <a
                  href=""
                  onClick={this.handleToggleClick}
                  title={this.trans('back','content.common')}
                >
                  {this.trans('backToEmail')}
                </a>
              </p>

              {isLoading
                ?
                <LoadingSpinner className="button button--expand" />
                :
                <button className="button button--expand">{this.trans('changePasswordButton')}</button>
              }
            </fieldset>
          </form>
        </div>
      </Fragment>
    );
  }
}

export default NewPasswordAndCode;